export const FASHION = "FASHION";
export const TRAVEL = "TRAVEL";
export const HEALTH_AND_FITNESS  = "HEALTH_AND_FITNESS";
export const BEAUTY_AND_MAKEUP = "BEAUTY_AND_MAKEUP";
export const NEWS_AND_POLITICS = "NEWS_AND_POLITICS";
export const MUSIC = "MUSIC";
export const HOME_AND_LIFESTYLE = "HOME_AND_LIFESTYLE";
export const PETS_AND_ANIMALS = "PETS_AND_ANIMALS";
export const ART_AND_ARCHITECTURE = "ART_AND_ARCHITECTURE";
export const SPORTS = "SPORTS";
export const COMICS_AND_ANIME = "COMICS_AND_ANIME";
export const GAMING = "GAMING";
export const AUTOS = "AUTOS";
export const SCIENCE = "SCIENCE";
export const COMEDY_AND_FUN = "COMEDY_AND_FUN";
export const PARENTING = "PARENTING";
export const FOOD_AND_DRINK = "FOOD_AND_DRINK";
export const PHOTOGRAPHY = "PHOTOGRAPHY";
export const HISTORY = "HISTORY";
export const ASTRONOMY = "ASTRONOMY";
export const EDUCATION = "EDUCATION";
export const BUISNESS = "BUISNESS";
export const TECHNOLOGY = "TECHNOLOGY";
export const MOVIES = "MOVIES";
export const BOOKS_AND_LITERATURE = "BOOKS_AND_LITERATURE";
export const RELIGION = "RELIGION";